/* Aura PDP - generated from public/landers/aura/script.js with the Shopify
   form wiring added. Edit the source, then re-run shopify/build.py. */
/* Aura PDP — vanilla, dependency-free, idempotent.
   Gallery · flavour · plan panels · bundle tiers · detail panel · accordions ·
   offer countdown · scroll reveal · counters · sticky bar. */
(function () {
  if (window.__auraLanderInit) return;
  window.__auraLanderInit = true;

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var gbp = function (n) { return '£' + n.toFixed(2); };

  /* ── Gallery ─────────────────────────────────────────────────────────── */
  function gallery() {
    var thumbs = $$('.a-gal__thumb');
    var slides = $$('.a-gal__slide');
    if (!thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-go');
        thumbs.forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-selected', 'false'); });
        slides.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-slide') === i); });
        t.classList.add('is-on');
        t.setAttribute('aria-selected', 'true');
      });
    });
  }

  /* ── Buy box ─────────────────────────────────────────────────────────── */
  function activePlan() { return $('.a-plan.is-on') || $('.a-plan'); }

  // Fill the detail panel of one plan from whichever tier is selected in it.
  function paintPlan(plan) {
    var tier = $('.a-tier.is-on', plan) || $('.a-tier', plan);
    if (!tier) return;
    var d = function (k) { return tier.getAttribute('data-' + k) || ''; };
    var now = parseFloat(d('now')) || 0;
    var was = parseFloat(d('was'));

    var set = function (sel, val) { var el = $(sel, plan); if (el) el.textContent = val; };
    set('[data-d-save]', d('save'));
    set('[data-d-qty]', d('qty'));
    set('[data-d-each]', '£' + d('each') + ' per serving');
    set('[data-d-now]', gbp(now));
    set('[data-d-cadence]', d('cadence'));
    set('[data-d-ongoing]', d('ongoing'));

    var wasEl = $('[data-d-was]', plan);
    if (wasEl) {
      wasEl.textContent = isNaN(was) ? '' : gbp(was);
      wasEl.style.display = isNaN(was) ? 'none' : '';
    }
  }

  // The sticky bar always mirrors the plan and tier that are actually selected.
  function paintSticky() {
    var plan = activePlan();
    if (!plan) return;
    var tier = $('.a-tier.is-on', plan) || $('.a-tier', plan);
    if (!tier) return;
    var now = parseFloat(tier.getAttribute('data-now')) || 0;
    var was = parseFloat(tier.getAttribute('data-was'));
    var p = $('[data-sticky-price]'); if (p) p.textContent = gbp(now);
    var w = $('[data-sticky-was]');
    if (w) { w.textContent = isNaN(was) ? '' : gbp(was); w.style.display = isNaN(was) ? 'none' : ''; }
  }

  function paintAll() {
    $$('.a-plan').forEach(paintPlan);
    paintSticky();
  }

  /* ── Flavour mix ──────────────────────────────────────────────────────
     Tins are allocated across the flavours, NOAT-style. The tin count comes
     from whichever tier is selected, so changing supply re-allocates. */
  function tinsForSelectedTier() {
    var plan = activePlan(); if (!plan) return 0;
    var tier = $('.a-tier.is-on', plan) || $('.a-tier', plan);
    return tier ? (parseInt(tier.getAttribute('data-tins'), 10) || 0) : 0;
  }


  /* How many tins of this flavour Shopify says exist. -1 means "not tracked",
     which is also what the static build reports, so the cap simply never bites. */
  function stockFor(card) {
    var s = card.getAttribute('data-stock');
    if (s === null || s === '') return -1;
    var n = parseInt(s, 10);
    return isNaN(n) ? -1 : n;
  }
  function soldOut(card) { return card.getAttribute('data-avail') === 'false' || stockFor(card) === 0; }

  function mixCards() { return $$('[data-mixcard]'); }
  function mixCount(card) { var b = $('[data-mix-n]', card); return b ? (parseInt(b.textContent, 10) || 0) : 0; }
  function mixTotal() { return mixCards().reduce(function (t, c) { return t + mixCount(c); }, 0); }

  function paintMix() {
    var cards = mixCards();
    if (!cards.length) return;
    var tins = tinsForSelectedTier();
    var used = mixTotal();
    var left = tins - used;

    cards.forEach(function (c) {
      var n = mixCount(c);
      c.classList.toggle('is-on', n > 0);
      var minus = $('[data-mix-minus]', c), plus = $('[data-mix-plus]', c);
      if (minus) minus.disabled = n <= 0;
      if (plus) {
        var canBorrow = cards.some(function (o) { return o !== c && mixCount(o) > 0; });
        var cap = stockFor(c);
        plus.disabled = (left <= 0 && !canBorrow) || (cap >= 0 && n >= cap);
      }
      c.classList.toggle('is-out', soldOut(c));
    });

    var chip = $('[data-mix-count]');
    if (chip) {
      chip.textContent = left > 0
        ? left + ' of ' + tins + ' tins left to choose'
        : 'All ' + tins + ' tins chosen';
      chip.classList.toggle('is-done', left <= 0);
    }

    // Summary line, the gallery skin and the sticky bar all follow the mix, so a
    // change of flavour is impossible to miss.
    var chosen = cards.filter(function (c) { return mixCount(c) > 0; });
    var summary = $('[data-mix-summary]');
    if (summary) {
      summary.innerHTML = chosen.length
        ? 'Your mix: ' + chosen.map(function (c) {
            return '<b>' + mixCount(c) + ' \u00d7 ' + c.getAttribute('data-flavour') + '</b>';
          }).join(' &middot; ')
        : '<em>Pick your tins above.</em>';
    }

    if (!chosen.length) {
      syncShopify();
      var sf0 = $('[data-sticky-flavour]');
      if (sf0) sf0.textContent = '';
      var s0 = $('[data-mix-summary]');
      if (s0) s0.innerHTML = '<em>Pick a flavour above.</em>';
      return;
    }
    var lead = chosen[0] || cards[0];
    var stage = $('[data-gal-stage]');
    if (stage) {
      stage.classList.remove('a-gal__stage--mint', 'a-gal__stage--berry');
      stage.classList.add('a-gal__stage--' + (chosen.length > 1 ? 'mint' : (lead.getAttribute('data-skin') || 'mint')));
    }
    var flavChip = $('[data-gal-flav]');
    if (flavChip) {
      var label = chosen.length > 1 ? 'Mixed tins' : lead.getAttribute('data-flavour');
      flavChip.innerHTML = '<i style="background:' + (lead.getAttribute('data-colour') || '#a9dcd5') + '"></i>' + label;
    }
    syncShopify();
    var sf = $('[data-sticky-flavour]');
    if (sf) sf.textContent = ' \u00b7 ' + (chosen.length > 1 ? 'Mixed' : lead.getAttribute('data-flavour'));
  }

  function setMix(card, n) { var b = $('[data-mix-n]', card); if (b) b.textContent = n; }

  /* null until the customer picks one - that's what keeps the price breakdown
     and the Add to Cart button hidden on arrival. */
  function flavMode() {
    var el = $('.a-flav__item.is-on');
    return el ? el.getAttribute('data-flav-mode') : null;
  }

  /* The flavour block exists once and moves into whichever plan card is open,
     so switching between Subscribe and One Time doesn't lose the choice. */
  function mountFlavour() {
    var block = $('[data-flavblock]'), plan = activePlan();
    if (!block || !plan) return;
    var slot = $('[data-flav-slot]', plan);
    if (slot && block.parentNode !== slot) slot.appendChild(block);
  }

  /* Nudge something into view without yanking the page around - only moves if
     it isn't already on screen. */
  function reveal_(el) {
    if (!el) return;
    try { el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
    catch (e) { el.scrollIntoView(false); }
  }

  /* One flavour, the other, a mix, or nothing yet. Called on a change of orb and
     whenever the tin count changes, so the split always adds up to what's bought. */
  function applyFlavMode(mode, scroll) {
    var cards = mixCards(); if (!cards.length) return;
    var tins = tinsForSelectedTier();
    var panel = $('[data-mix]');
    if (panel) panel.hidden = mode !== 'mix';

    if (mode === 'mix') {
      // Split it down the middle on the way in, so Mix means something the
      // moment it's picked rather than sitting at zero.
      var base = Math.floor(tins / cards.length), rem = tins % cards.length;
      cards.forEach(function (c, i) { setMix(c, base + (i < rem ? 1 : 0)); });
    } else if (mode) {
      // mode is 'f1', 'f2', ... - the index of the flavour block.
      var want = parseInt(mode.replace('f', ''), 10) - 1;
      if (isNaN(want) || want < 0) want = 0;
      cards.forEach(function (c, i) { setMix(c, i === want ? tins : 0); });
    } else {
      cards.forEach(function (c) { setMix(c, 0); });
    }

    // Price breakdown and Add to Cart stay hidden until a flavour is chosen.
    $$('.a-plan').forEach(function (p) { p.classList.toggle('has-flav', !!mode && p === activePlan()); });

    paintMix();
    if (scroll) reveal_(mode === 'mix' ? panel : $('.a-plan.is-on .a-detail'));
  }

  function resetMix() { applyFlavMode(flavMode()); }

  /* An orb for a flavour Shopify has run out of is disabled rather than hidden,
     so the range on offer still reads the same and the customer knows it exists. */
 function paintFlavourStock() {
  var cards = mixCards();

  /* Only Aura's ORIGINAL flavour controls.
     Custom bundle uses the same .a-flav__item class
     but does not use data-flav-mode. */
  $$('.a-flav__item[data-flav-mode]').forEach(function (item) {

    var mode = item.getAttribute('data-flav-mode');

    if (!mode) return;
    if (mode === 'mix') return;

    var i = parseInt(mode.replace('f', ''), 10) - 1;

    if (isNaN(i) || i < 0) return;

    var card = cards[i];

    if (!card) return;

    var out = soldOut(card);

    item.classList.toggle('is-out', out);
    item.disabled = out;

    if (out) {
      item.setAttribute('title', 'Out of stock');
    }
  });
}

  function buybox() {
    paintFlavourStock();
    // The three orbs
    $$('.a-flav__item[data-flav-mode]').forEach(function (item) {
      item.addEventListener('click', function () {
        $$('.a-flav__item[data-flav-mode]').forEach(function (o) {
          o.classList.toggle('is-on', o === item);
          o.setAttribute('aria-checked', o === item ? 'true' : 'false');
        });
        applyFlavMode(item.getAttribute('data-flav-mode'), true);
      });
    });

    // Flavour steppers
    mixCards().forEach(function (card) {
      var b = $('[data-mix-n]', card);
      var plus = $('[data-mix-plus]', card), minus = $('[data-mix-minus]', card);
      if (plus) plus.addEventListener('click', function () {
        var cap = stockFor(card);
        if (cap >= 0 && mixCount(card) >= cap) return;
        // At capacity, adding one takes it from whichever flavour has the most.
        // Going 6 mint -> "4 mint, 2 berry" should be two taps on +, not four.
        if (mixTotal() >= tinsForSelectedTier()) {
          var donor = mixCards()
            .filter(function (c) { return c !== card && mixCount(c) > 0; })
            .sort(function (x, y) { return mixCount(y) - mixCount(x); })[0];
          if (!donor) return;
          $('[data-mix-n]', donor).textContent = mixCount(donor) - 1;
        }
        b.textContent = mixCount(card) + 1; paintMix();
      });
      if (minus) minus.addEventListener('click', function () {
        if (mixCount(card) <= 0) return;
        b.textContent = mixCount(card) - 1; paintMix();
      });
    });

    // Plan panels — one open at a time
    $$('[data-plan-head]').forEach(function (head) {
      head.addEventListener('click', function () {
        var plan = head.closest('.a-plan');
        $$('.a-plan').forEach(function (p) {
          p.classList.toggle('is-on', p === plan);
          var h = $('[data-plan-head]', p);
          if (h) h.setAttribute('aria-expanded', p === plan ? 'true' : 'false');
        });
        paintSticky();
        mountFlavour();
        applyFlavMode(flavMode());
      });
    });

    // Bundle tiers — selection is per plan
    $$('.a-tier').forEach(function (tier) {
      tier.addEventListener('click', function () {
        var plan = tier.closest('.a-plan');
        $$('.a-tier', plan).forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-checked', 'false'); });
        tier.classList.add('is-on');
        tier.setAttribute('aria-checked', 'true');
        paintPlan(plan);
        paintSticky();
        applyFlavMode(flavMode(), true);
      });
    });

    // Nothing is wired to a real cart on the static build.
    $$('[data-atc]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); }); });

    paintAll();
    mountFlavour();
    resetMix();
    syncShopify();
  }

  /* ── Accordions ──────────────────────────────────────────────────────── */
  function accordions() {
    $$('[data-accordion]').forEach(function (acc) {
      $$('[data-acc-item]', acc).forEach(function (item) {
        if (item.hasAttribute('data-open')) item.classList.add('is-open');
        var trigger = $('[data-acc-trigger]', item);
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          $$('[data-acc-item]', acc).forEach(function (o) {
            o.classList.remove('is-open');
            var t = $('[data-acc-trigger]', o);
            if (t) t.setAttribute('aria-expanded', 'false');
          });
          item.classList.toggle('is-open', !open);
          trigger.setAttribute('aria-expanded', !open ? 'true' : 'false');
        });
      });
    });
  }

  /* ── Offer countdown ─────────────────────────────────────────────────── */
  function countdown() {
    var el = $('[data-countdown-to-hours]');
    if (!el) return;
    var hours = parseFloat(el.getAttribute('data-countdown-to-hours')) || 12;
    var left = Math.round(hours * 3600);
    var hh = $('[data-cd-hh]', el), mm = $('[data-cd-mm]', el), ss = $('[data-cd-ss]', el);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    (function tick() {
      if (hh) hh.textContent = pad(Math.floor(left / 3600));
      if (mm) mm.textContent = pad(Math.floor(left / 60) % 60);
      if (ss) ss.textContent = pad(left % 60);
      if (left > 0) { left--; setTimeout(tick, 1000); }
    })();
  }

  /* ── Scroll reveal ───────────────────────────────────────────────────── */
  function reveal() {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = parseInt(e.target.getAttribute('data-reveal-delay') || '0', 10);
        setTimeout(function () { e.target.classList.add('is-in'); }, isNaN(d) ? 0 : d);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ── Counters ────────────────────────────────────────────────────────── */
  function counters() {
    var els = $$('[data-count-to]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-count-to')) || 0;
        var suffix = el.getAttribute('data-count-suffix') || '';
        var dec = (String(target).split('.')[1] || '').length;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / 1300, 1);
          var v = target * (1 - Math.pow(1 - p, 3));
          el.textContent = Number(v.toFixed(dec)).toLocaleString('en-GB', { minimumFractionDigits: dec }) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ── Sticky bar ──────────────────────────────────────────────────────── */
  function stickyBar() {
    var bar = $('[data-sticky-bar]');
    var hero = $('.a-hero');
    if (!bar) return;
    var onScroll = function () {
      var past = hero ? (hero.getBoundingClientRect().bottom < 0) : (window.scrollY > window.innerHeight);
      bar.classList.toggle('is-visible', past);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ── Tabbed "what it covers" ──────────────────────────────────────────── */
  function tabs() {
    var tabEls = $$('.a-tab');
    if (!tabEls.length) return;
    tabEls.forEach(function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-tab');
        tabEls.forEach(function (o) { o.classList.remove('is-on'); o.setAttribute('aria-selected', 'false'); });
        t.classList.add('is-on');
        t.setAttribute('aria-selected', 'true');
        $$('.a-tabpanel').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-panel') === key); });
      });
    });
  }

  /* The bar shows all three lines side by side on desktop and one at a time on
     mobile, so it only rotates when the CSS has actually collapsed it. */
  function announcement() {
    var msgs = $$('.a-annc__msg');
    if (msgs.length < 2) return;
    var mq = window.matchMedia('(max-width: 700px)');
    var i = 0;
    setInterval(function () {
      if (!mq.matches) return;
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 3200);
  }


  /* ── Shopify ───────────────────────────────────────────────────────────
     Everything above is presentation. These three keep the hidden form
     fields in step with what the customer has actually chosen, so the cart
     gets the right variant, the right selling plan, and a mix the warehouse
     can read. */

  function syncVariant() {
    var plan = activePlan(); if (!plan) return;
    var tier = $('.a-tier.is-on', plan) || $('.a-tier', plan);
    var input = $('[data-variant-id]');
    if (tier && input) input.value = tier.getAttribute('data-variant') || '';
  }

  function syncSellingPlan() {
    var plan = activePlan(), input = $('[data-selling-plan]');
    if (!plan || !input) return;
    var id = plan.getAttribute('data-selling-plan') || '';
    input.value = id;
    // A blank selling plan must not be submitted at all, or Shopify rejects
    // the line as an invalid subscription.
    input.disabled = id === '';
  }

  /* The mix goes on the order as line item properties: one per flavour plus a
     readable summary. Zero-count flavours are disabled so they are not
     submitted - nobody wants "Berry Lemonade: 0" on a packing slip. */
  function syncMixProperties() {
    var parts = [];
    mixCards().forEach(function (card) {
      var name = card.getAttribute('data-flavour');
      var n = mixCount(card);
      var input = $('[data-prop-flavour="' + name + '"]');
      if (input) { input.value = n; input.disabled = n <= 0; }
      if (n > 0) parts.push(n + ' x ' + name);
    });
    var summary = $('[data-prop-mix]');
    if (summary) {
      summary.value = parts.join(', ');
      summary.disabled = parts.length === 0;
    }
  }

  function syncShopify() { syncVariant(); syncSellingPlan(); syncMixProperties(); }

  function boot() {
    gallery(); buybox(); accordions(); countdown(); tabs(); reveal(); counters(); stickyBar();
    announcement();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
